import { render, staticRenderFns } from "./About Us Template.vue?vue&type=template&id=7e25c526&scoped=true&comments=true&"
import script from "./About Us Template.vue?vue&type=script&lang=js&"
export * from "./About Us Template.vue?vue&type=script&lang=js&"
import style0 from "./About Us Template.vue?vue&type=style&index=0&id=7e25c526&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e25c526",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIHeader: require('/opt/build/repo/components/UI/Header.vue').default,CartBannerTop: require('/opt/build/repo/components/Cart/BannerTop.vue').default,AboutUsFooter: require('/opt/build/repo/components/AboutUs/Footer.vue').default})
